
import {Component, Vue} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {VekaletUcretDonemEntity} from "@/entity/VekaletUcretDonemEntity";
import {AxiosResponse} from "axios";

@Component({
  components: {FormDialog, DeleteDialog},
})
export default class VekaletUcretleriList extends Vue {
  items: any = [];
  selectedItem: any = new VekaletUcretDonemEntity();

  headers = [
    {text: "Alt Sınır", value: "alt_sinir",align:'start'},
    {text: "Üst Sınır", value: "ust_sinir",align:'start'},
    {text: "Borçlu Oran", value: "borclu_oran",align:'center'},
  ];

  mounted() {
    this.loadVekaletUcretleri();
  }

  loadVekaletUcretleri() {
    this.$helper.requestWithCache("/api/v1/vekalet-ucret-list").then((response) => {
      this.items = response;
      this.items.reverse();
      this.selectedItem = this.items[0];

      this.items.forEach((donem:any) => {
        donem.text = donem.baslangic_tarihi ? this.$helper.tarihStr(donem.baslangic_tarihi) : "";
      });
    });
  }
}
